import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Renders invoice gap details:
 *   context.mode      : 'per-day' | 'per-prefix' | ...
 *   context.date      : ISO date
 *   context.prefix    : string
 *   context.before    : { invoice_no }
 *   context.after     : { invoice_no }
 *   context.missing   : string[]   (the missing invoice numbers/labels)
 *   context.gap_size  : number
 *   context.total_for_day : number
 */
export default function InvoiceGapList({ context }) {
    const { t } = useTranslation();
    if (!context) return null;
    const before = context.before?.invoice_no || context.before || '—';
    const after = context.after?.invoice_no || context.after || '—';
    const missing = Array.isArray(context.missing) ? context.missing : [];
    const total = context.total_for_day;
    const gap = context.gap_size != null ? context.gap_size : missing.length;
    const pct = total ? ((gap / total) * 100).toFixed(1) : null;

    return (
        <div>
            <dl className="v3-anomalies-kv">
                <dt>{t('Mode')}</dt>      <dd>{context.mode || '—'}</dd>
                <dt>{t('Date')}</dt>      <dd>{context.date || '—'}</dd>
                <dt>{t('Prefix')}</dt>    <dd>{context.prefix || '—'}</dd>
                <dt>{t('Before')}</dt>    <dd style={{ fontFamily: 'JetBrains Mono, monospace' }}>{before}</dd>
                <dt>{t('After')}</dt>     <dd style={{ fontFamily: 'JetBrains Mono, monospace' }}>{after}</dd>
                {total != null && (
                    <>
                        <dt>{t('Total for day')}</dt>
                        <dd>{t('{{total}} invoices · gap {{gap}}', { total, gap })}{pct != null && ` (${pct}%)`}</dd>
                    </>
                )}
            </dl>

            {missing.length > 0 && (
                <>
                    <h4 style={{ fontSize: 11, marginTop: 12, color: 'var(--v3-text-muted)', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
                        {t('Missing invoices ({{count}})', { count: missing.length })}
                    </h4>
                    <div className="v3-anomalies-pills">
                        {missing.slice(0, 50).map((m, i) => (
                            <span key={`${m}-${i}`} className="v3-anomalies-pill">{m}</span>
                        ))}
                        {missing.length > 50 && (
                            <span style={{ fontSize: 11, color: 'var(--v3-text-muted)', alignSelf: 'center' }}>
                                {t('+{{count}} more', { count: missing.length - 50 })}
                            </span>
                        )}
                    </div>
                </>
            )}
        </div>
    );
}
